import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { logDebugEvent, logException } from "@sazka/utils/logger/use-app-logger";

function getRequestConfig(request: AxiosRequestConfig<any>) {
    return {
        baseUrl: request.baseURL,
        method: request.method,
        url: request.url,
        body: JSON.parse(JSON.stringify(request.data ?? {})),
    };
}

function getResponseData(response: AxiosResponse<any, any>) {
    return {
        status: response.status,
        statusText: response.statusText,
        body: JSON.parse(JSON.stringify(response.data ?? {})),
    };
}

function getErrorData(error: AxiosError) {
    const data: any = error.toJSON();
    return {
        status: data?.status,
        message: data?.message,
    };
}

export function logRequest(request: AxiosRequestConfig<any>) {
    logDebugEvent("kasa-apis", "KASA-api-request", getRequestConfig(request));
}

export function logResponse(response: AxiosResponse<any, any>) {
    logDebugEvent("kasa-apis", "KASA-api-response", getResponseData(response));
}

export function logError(error: AxiosError) {
    logException("KASA-api-error", error, getErrorData(error));
}
